import { render, staticRenderFns } from "./FoodInTable.vue?vue&type=template&id=38e7c2bc&scoped=true"
import script from "./FoodInTable.vue?vue&type=script&lang=js"
export * from "./FoodInTable.vue?vue&type=script&lang=js"
import style0 from "./FoodInTable.vue?vue&type=style&index=0&id=38e7c2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e7c2bc",
  null
  
)

export default component.exports